"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageWHPJ = void 0;
var react_1 = __importDefault(require("react"));
var crumbs_1 = require("../crumbs");
var maintab_1 = require("./shared/maintab");
var quotetable_1 = require("../quotetable");
/**
 * 外汇市场-外汇牌价
 */
function PageWHPJ() {
    return (react_1.default.createElement("div", { className: "whpj" },
        react_1.default.createElement(crumbs_1.CrumbsWithRefresh, null),
        react_1.default.createElement(maintab_1.MainTab3, { class: "maintab" }),
        react_1.default.createElement(quotetable_1.QuoteTable, null)));
}
exports.PageWHPJ = PageWHPJ;
